module.exports = __webpack_public_path__ + "media/images/icon__close--rb-dark-gray@2x-329d7b74fefd29348e7a067b0d7bb084.png";